// extracted by mini-css-extract-plugin
export default {"OsmMarkerPopUp":"style_OsmMarkerPopUp__D3q-P","OsmMarkerPopUpName":"style_OsmMarkerPopUpName__hU6ie","OsmMarkerPopUpButton":"style_OsmMarkerPopUpButton__AC4E7"};